var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navContainer" },
    [
      _c("nav", { staticClass: "main" }, [
        _c("div", { staticClass: "clearfix container" }, [
          _c(
            "div",
            { staticClass: "fl" },
            [
              _c(
                "router-link",
                {
                  staticStyle: { display: "inline-block" },
                  attrs: { to: "/" }
                },
                [
                  _c("img", {
                    attrs: { src: _vm.url + _vm.webInfo.siteLogo, alt: "logo" }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "fr" }, [
            _c("div", { staticClass: "navLIst" }, [
              _c(
                "ul",
                _vm._l(_vm.navList, function(item, i) {
                  return _c(
                    "li",
                    { key: i },
                    [
                      item.isOutLink != 1
                        ? _c(
                            "router-link",
                            {
                              staticClass: "transt",
                              attrs: { to: item.siteUrl }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                        : _c(
                            "a",
                            {
                              staticClass: "transt",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.goNewPage(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                    ],
                    1
                  )
                }),
                0
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Messages", { ref: "messages", attrs: { tips: _vm.tipsTxt } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-068a1892", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-068a1892","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/TopMenu.vue
// module id = null
// module chunks = 